import { useDispatch, useSelector } from "react-redux";
import { handleChangeDataModalRating } from 'reduxx/actions/partials/modals/modalRating';
import { handleChangeDataVisitHistoryPage } from 'reduxx/actions/pages/myAdvice/history';
import modalStyles from 'styles/css/Modal.module.scss';
import historyStyles from 'styles/css/VisitHistory.module.scss';
import sharedStyles from 'styles/css/SharedStyles.module.scss';
import shortHeaderStyles from 'styles/css/ShortHeaderStyles.module.scss';
import actionStyles from 'styles/css/ActionStyles.module.scss';
import CloseIcon from 'styles/images/svg/close.svg';
import { API_RATING } from 'apis';
import apiRequest from 'utils/apiRequest';
import Logo from 'styles/images/logo/logo512.png';
import Swal from 'sweetalert2';

import React from 'react';
import Rating from '@mui/material/Rating';
import StarIcon from '@mui/icons-material/Star'; // آیکون ستاره از MUI


const ModalRating = (props) => {

	const dispatch = useDispatch();

	const { token } = useSelector(state => state.login);
	const { isOpen, data, rate } = useSelector(state => state.modalRating);
	const { history } = useSelector(state => state.visitHistory);

	const handleClose = () => {
        dispatch(handleChangeDataModalRating('isOpen', false));
    };    


    const toPersianDigits = (num) => {
        return num.toString().replace(/\d/g, d => '۰۱۲۳۴۵۶۷۸۹'[d]);
    };

    const apiRating = () => {
    	apiRequest({
            dispatch,
            endpoint: API_RATING,
            method: 'post',
            data: { visitCode: data.uniqueCode, rate },
            token: token,
            successMessage: null,
            onSuccess: (res) => {

            	const buttonOkSingle = Swal.mixin({
		            customClass: {
		                confirmButton: actionStyles['btn-accept'],
		                cancelButton: [actionStyles['btn-cancel'], actionStyles['mr-12']].join(' '),
		            },
		            buttonsStyling: false
		        });

		        buttonOkSingle.fire({
		            text: "امتیاز شما با موفقیت ثبت شد",
		            imageUrl: Logo,
		            imageHeight: 80,
		            imageAlt: 'دکتر20',
		            confirmButtonText: "باشه",
		            showCancelButton: false,
		        }).then((result) => {
		            if (result.isConfirmed) {
		                let newHistory = history.map((his, index) => {
		        			if(his.uniqueCode === data.uniqueCode)
		        				return { ...his, rate: `${rate}` };
		        			return his;
		        		});

		            	dispatch(handleChangeDataVisitHistoryPage('history', newHistory));
		            	dispatch(handleChangeDataModalRating('isOpen', false));
		            }
		        }); 

            },
        });
    };


    return (
    	<div>

    	{isOpen && (
		  	<div className={modalStyles["custom-modal-backdrop"]} onClick={handleClose}>
			    <div className={modalStyles["custom-modal"]} onClick={e => e.stopPropagation()}>

			    	<div className={[sharedStyles.flex, sharedStyles['flex-col'], sharedStyles.itemsCenter].join(' ')} >

			    		<div className={[sharedStyles['w-full'], sharedStyles.flex, sharedStyles.justifyBetween, sharedStyles.itemsCenter].join(' ')} >
			    			<h4 style={{marginTop: "0px", marginBottom: "0px"}}>ثبت نظر</h4>

			    			<img onClick={handleClose} className={shortHeaderStyles['back-btn']} src={CloseIcon} width={18} height={18}  />
			    		</div>

			    		<div style={{height: "1px", backgroundColor: "#e3e3e3", margin: "16px -16px", width: "calc(100% + 32px)", boxSizing: "border-box"}} />

			    		<div className={[sharedStyles['w-full'], sharedStyles.flex, sharedStyles.justifyBetween].join(' ')} >
			    			<span>شماره درخواست:</span>
			    			<span className={sharedStyles['font-weight-600']}>{data.uniqueCode}</span>
			    		</div>
			    		<div className={[sharedStyles['w-full'], sharedStyles.flex, sharedStyles.justifyBetween, sharedStyles['mt-[8px]']].join(' ')} >
			    			<span>پزشک:</span>
			    			<span className={sharedStyles['font-weight-600']}>{data.doctorName}</span>
			    		</div>


			    		<Rating
				            name="simple-controlled"
				            value={rate}
				            onChange={(event, newValue) => {
				            	dispatch(handleChangeDataModalRating('rate', newValue))
				            }}
				            precision={1} // دقت امتیازدهی (1 یعنی فقط اعداد صحیح مثل 1، 2، 3، 4، 5)
				            max={5} // حداکثر امتیاز (5 ستاره)
				            emptyIcon={<StarIcon style={{ opacity: 0.55 }} fontSize="3rem" />} // 
				            // defaultValue={3}
				            // readOnly={true} // اگر نمیخوای کاربر بتونه تغییر بده
				            sx={{fontSize: "3rem", direction: "ltr", marginTop: "32px"}}
			          	/>
			          	{rate !== null && (
				            <p>امتیاز شما: {toPersianDigits(rate)} از {toPersianDigits(5)}</p>
			          	)}


			          	<div className={[sharedStyles["w-full"], sharedStyles.flex, sharedStyles.itemsCenter, sharedStyles.gapLg, sharedStyles['mt-[32px]']].join(' ')}>
                            <span onClick={handleClose} className={[historyStyles.btn, historyStyles.btnDetailsOff, sharedStyles['flex-1'], sharedStyles.flex, sharedStyles.justifyCenter].join(' ')} >
                            	انصراف
                            </span>

                            <span onClick={apiRating} className={[historyStyles.btn, historyStyles.btnRating, sharedStyles['flex-2'], sharedStyles.flex, sharedStyles.justifyCenter].join(' ')} >
                                ثبت امتیاز
                            </span>
                        </div>


			    	</div>
			      	


			    </div>
		  	</div>
		)}

		</div>
        
    );
}

export default ModalRating;
